var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filed is-centered" }, [
    _c(
      "div",
      { staticClass: "control" },
      [
        _c(
          "RouterLink",
          {
            staticClass: "button is-text is-white is-inverted",
            attrs: { to: { name: "ForgottenPassword" } }
          },
          [_vm._v("\n      ¿olvidaste tu contraseña?\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }